/**
 * Pre-order, on the product page.
 *
 * A sold-out size normally leaves a dead button and a "tell me when it's back"
 * form. Where a rule covers this product, that size becomes buyable instead:
 * the button says Pre-order, the despatch date sits under it, and the date is
 * written onto the cart line so it reaches the order rather than living only on
 * the page that sold it.
 *
 * It is decided per size, not per product. A 40 on the shelf is bought
 * normally; the 44 that ran out is pre-ordered. Which means this has to run
 * again every time the picker changes, and after the theme's own script has
 * finished rewriting the button.
 */
(function () {
  'use strict';

  var L = labelsOf(document.querySelector('[data-tcfr]'));
  /* The words this script says, in the page's language: the section writes
     them into data-labels on its root from the theme's locale files, which
     locales-sync.js fills from the table the apps and the admin panel share.
     English is the floor. The translation filter HTML-escapes, so the
     entities are undone. */
  function labelsOf(node) {
    var out = {};
    try {
      var raw = JSON.parse((node && node.getAttribute('data-labels')) || '{}');
      for (var k in raw) if (Object.prototype.hasOwnProperty.call(raw, k) && typeof raw[k] === 'string') {
        out[k] = raw[k].replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
      }
    } catch (e) { /* no labels: English */ }
    return out;
  }
  function tr(key, fallback) {
    var v = L[key];
    var out = (typeof v === 'string' && v && v.indexOf('translation missing') !== 0) ? v : fallback;
    for (var i = 2; i < arguments.length; i++) out = out.replace('%s', arguments[i]);
    return out;
  }

  function setup(root) {
    if (root.__tcPreorder) return;
    root.__tcPreorder = true;

    var form = root.querySelector('form[action*="/cart/add"]');
    var cta = root.querySelector('[data-tcfr-add]');
    var idInput = root.querySelector('[data-tcfr-id]');
    var productId = root.getAttribute('data-tcfr-product');
    if (!form || !cta || !idInput || !productId) return;

    var rule = null;
    var variants = null;
    var original = { text: null, disabled: null };

    try {
      var map = root.querySelector('[data-tcfr-variants]') ||
                (root.parentNode && root.parentNode.querySelector('[data-tcfr-variants]')) ||
                document.querySelector('[data-tcfr-variants]');
      variants = map ? JSON.parse(map.textContent) : null;
    } catch (e) { variants = null; }

    fetch('/apps/tru/preorder/' + encodeURIComponent(productId), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.active) return;
        rule = data;
        apply();
        /* Listen on the block, not the form. The size picker is rendered above
           the cart form and is not inside it, so a change there never reaches
           the form — the button stayed as it was and nothing here ran. The
           picker also rewrites the button on every change, so re-decide after
           it has had its turn rather than fighting it for the same element. */
        root.addEventListener('change', function () { setTimeout(apply, 60); });
        document.addEventListener('variant:change', function () { setTimeout(apply, 60); });
      })
      .catch(function () { /* no rule, or the proxy is unwell: leave the page be */ });

    function chosen() {
      var id = String(idInput.value || '');
      if (!variants) return { id: id, available: null };
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return { id: id, available: !!variants[i].available };
      }
      return { id: id, available: null };
    }

    function fields(on) {
      /* Written as ordinary line item properties, so they show in the basket,
         at checkout and on the order — the warehouse reads the order, not this
         page. Removed again when the chosen size is in stock, or every normal
         purchase would claim to be a pre-order. */
      var existing = form.querySelectorAll('[data-tc-preorder-field]');
      for (var i = 0; i < existing.length; i++) existing[i].remove();
      if (!on) return;

      var add = function (name, value) {
        if (!value) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.value = value;
        input.setAttribute('data-tc-preorder-field', '');
        form.appendChild(input);
      };
      add('Pre-order', 'Yes');
      /* The name says which promise the date is, because it is read in the
         basket and on the order: the day it leaves, or the latest it arrives. */
      add(rule.dateMeans === 'delivery' ? 'Estimated delivery by' : 'Estimated despatch', rule.ships);
    }

    /**
     * Collection, for something that is not here yet.
     *
     * The shop's pickup block says "Pickup available at TruClothing Plaistow —
     * usually ready in 4 hours", which is true of stock on a shelf and a lie
     * about a boot arriving in September. The block is replaced for a
     * pre-ordered size with the same promise told honestly, and put back the
     * moment a size that is in stock is chosen.
     */
    function pickup(on) {
      var block = root.querySelector('.tcfr__pickup');
      if (!block) return;
      var mine = block.querySelector('[data-tc-preorder-pickup]');

      if (!on) {
        block.classList.remove('is-preorder');
        if (mine) mine.remove();
        return;
      }

      block.classList.add('is-preorder');
      /* "Collection from 1 September" on its own reads as though collection is
         the only way to get it. It is an extra: the boot is posted like
         anything else, and can also be picked up once it lands. */
      var wording = rule.ships
        ? tr('collection_from', 'Collection in store also available from %s', rule.ships)
        : tr('collection_arrives', 'Collection in store also available once it arrives');
      if (mine) {
        mine.querySelector('b').textContent = wording;
        return;
      }
      var line = document.createElement('p');
      line.className = 'tcfr__pickup-preorder';
      line.setAttribute('data-tc-preorder-pickup', '');
      var strong = document.createElement('b');
      strong.textContent = wording;
      line.appendChild(strong);
      line.appendChild(document.createTextNode(
        ' — or we post it to you as soon as it arrives.'));
      block.appendChild(line);
    }

    /**
     * The delivery promise, for something that has not arrived.
     *
     * "Order before 3:30pm tomorrow with Evri Next Day to get it Thursday" is
     * the same lie as the four-hour collection, told about the post. It is
     * hidden while a pre-ordered size is chosen — the despatch date directly
     * underneath is the honest version of the same sentence — and comes back
     * for a size that is on the shelf.
     */
    function delivery(on) {
      /* The store drawer lists "usually ready in 4 hours" against every shop,
         and it is rendered outside this block — so the page is marked instead
         and the stylesheet hides those lines wherever they are. */
      document.documentElement.classList.toggle('tc-preorder-on', !!on);
      var strip = root.querySelector('[data-tcfr-delivery]');
      if (strip) strip.classList.toggle('is-preorder-hidden', !!on);
      var cutoff = root.querySelector('[data-tcfr-cutoff]');
      if (cutoff) cutoff.classList.toggle('is-preorder-hidden', !!on);
    }

    function note(on) {
      var existing = root.querySelector('[data-tc-preorder-note]');
      if (!on) { if (existing) existing.remove(); return; }
      if (existing) {
        existing.querySelector('[data-tc-preorder-date]').textContent = rule.ships || '';
        return;
      }
      var box = document.createElement('div');
      box.className = 'tcfr__preorder';
      box.setAttribute('data-tc-preorder-note', '');
      var line = document.createElement('p');
      line.className = 'tcfr__preorder-when';
      line.appendChild(document.createTextNode(rule.dateMeans === 'delivery'
        ? tr('delivery_by', 'Estimated delivery by: ')
        : tr('despatch_date', 'Estimated despatch date: ')));
      var strong = document.createElement('b');
      strong.setAttribute('data-tc-preorder-date', '');
      strong.textContent = rule.ships || tr('to_be_confirmed', 'to be confirmed');
      line.appendChild(strong);
      box.appendChild(line);
      if (rule.message) {
        var msg = document.createElement('p');
        msg.className = 'tcfr__preorder-msg';
        msg.textContent = rule.message;
        box.appendChild(msg);
      }
      /* Under the button, where it is read after the decision to buy rather
         than as an obstacle before it. */
      cta.parentNode.insertBefore(box, cta.nextSibling);
    }

    function apply() {
      if (!rule) return;
      var pick = chosen();
      /* The server decides, from inventory quantity, which sizes are on
         pre-order — and that is the only workable test. Asking the page whether
         the size is sold out cannot work here: allowing a pre-order means
         setting the variant to sell past zero, at which point Shopify reports
         it as available and the check that started all this answers "no". */
      var on = !!(rule.variantIds && rule.variantIds.indexOf(pick.id) !== -1);

      if (on) {
        if (original.text === null) {
          original.text = cta.innerHTML;
          original.disabled = cta.disabled;
        }
        cta.disabled = false;
        cta.textContent = rule.label || tr('preorder', 'Pre-order');
        cta.classList.add('is-preorder');
        /* The back-in-stock form is for things that cannot be bought. This can. */
        var bis = root.querySelector('[data-tcfr-bis]');
        if (bis) bis.hidden = true;
      } else if (original.text !== null) {
        cta.innerHTML = original.text;
        cta.disabled = original.disabled;
        cta.classList.remove('is-preorder');
        original.text = null;
      }

      fields(on);
      note(on);
      pickup(on);
      delivery(on);
      /* Symmetry rebuilds the pickup block when the variant changes, which
         takes our line with it — so it is rewritten after that has happened,
         not only once. */
      setTimeout(function () { pickup(on); }, 300);
    }
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-tcfr]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
